import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-not-found',
  imports: [TranslocoPipe],
  template: `<span class="m-auto p-5 text-3xl text-white">
    {{ 'NOT_FOUND_PAGE.MESSAGE' | transloco }}
  </span>`,
  host: {
    class: 'flex h-full w-full background-color',
  },
})
export class NotFoundComponent {}
